
export const collectRefresh = state => state.collectRefresh

export const center = state => state.center

export const drops = state => state.drops


// WEBPACK FOOTER //
// ./src/store/getters.js